import { useMemo } from "react";

import CheckBoxesInput from "../../Input/CheckBoxesInput";
import Field, {
  FIELD_MODE_FIELDSET,
  FIELD_MODE_LABEL,
  FIELD_MODE_NO_FIELD
} from "../Field";
import { CHECKBOXES } from "../SchemaTypes";
import { useCheckboxesSchema } from "./useCheckboxesSchema";
import { useParsedFieldProps } from "./useParsedFieldProps";

const CheckBoxesField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const {
    required,
    maximumSelectableOptions,
    options,
    displayOtherField,
    parent,
    isCorrection
  } = props;

  const schema = useCheckboxesSchema({
    type: CHECKBOXES,
    singleOptionSelection: false,
    required,
    parent,
    maximumSelectableOptions
  });

  const fieldMode = useMemo(() => {
    if (isCorrection) {
      return FIELD_MODE_NO_FIELD;
    } else if (options.length > 1 || displayOtherField) {
      return FIELD_MODE_FIELDSET;
    } else {
      return FIELD_MODE_LABEL;
    }
  }, [displayOtherField, isCorrection, options.length]);

  return (
    <Field {...fieldProps} schema={schema} fieldMode={fieldMode}>
      <CheckBoxesInput {...inputProps} />
    </Field>
  );
};

export default CheckBoxesField;
